<template>
    <div class="height_100 py-4 " id="menu-bar-gpt">
        <div class="top w-100 pt-2">
            <!-- UpGPT標題 -->
            <div class="d-flex justify-space-between align-left mb-4 ml-9">
                <div class="logo" @mouseenter="mouseenter"
                @mouseleave="mouseleave">
                    <img :src="logoUrl" class="logo-img" >
                    <v-btn v-show='isAdmin=="true" && logoHover' icon='icon' small @click="triggerFile"><v-icon size='15'>mdi-pencil</v-icon></v-btn>
                    <input type="file" ref="fileInput" accept="image/*" style="display:none" @change="onLogoChange" />
                </div>
                <!-- <v-btn class="" icon @click="toUpDay()">
                    <v-icon size="40">mdi-alpha-u-box</v-icon>
                </v-btn> -->
            </div>
            <v-divider class="mx-4"></v-divider>
            <!-- Menubar 項目區 -->
            <v-list class="" :class="isToggle ? 'is-active' : ''" z-index='9999' dense>
                <v-list-item-group >
                    <!-- 加入各項目 -->
                    <template v-for="item in upMenuRouterFiltered">
                        <!-- 用戶管理特殊處理 -->
                        <v-menu bottom :offset-x="offset" nudge-right="0" v-if="item.name === $t('GPT_MENU.USER_MANAGEMENT')" open-on-hover :key="item.name" max-width="180">
                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item v-show='isAdmin=="true"' :class="{'v-list-item--active':$route.path.toLowerCase().includes('usermanagement') ||$route.path.toLowerCase().includes('groupmanagement')}" class="mb-1 pt-0 pt-1 pb-1" style="max-height:50px" v-bind="attrs" v-on="on">
                                <v-list-item-icon class="mr-2">
                                    <div v-if="$route.path.toLowerCase().includes('usermanagement') || $route.path.toLowerCase().includes('groupmanagement')" class="vlist-border"></div>
                                    <v-img :src="checkLink(item) ? item.active : item.normal" :width="24" :height="24" class="vlist-icon" cover/>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class= "vlist-font ">{{ item.name }}</v-list-item-title>
                                </v-list-item-content>
                                </v-list-item>
                            </template>
                            <v-list class="pa-0  " >
                                <v-list-item class=" " @click="toUserManagement()" >
                                     <v-list-item-title class= "menubarfont " style="">
                                        {{ $t('GPT_MENU.USER_MANAGEMENT') }}
                                     </v-list-item-title>
                                </v-list-item>
                                <v-list-item class="" @click="toGroupManagement()">
                                     <v-list-item-title class= "menubarfont ">
                                        {{ $t('GPT_MENU.GROUP_MANAGEMENT') }}
                                     </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <!-- 數據中心特殊處理 -->
                        <v-menu bottom :offset-x="offset" nudge-right="0" v-else-if="item.name === $t('GPT_MENU.DATA_CENTER')" open-on-hover :key="item.name" max-width="180">
                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item v-show='isAdmin=="true"' :class="{'v-list-item--active':$route.path.toLowerCase().includes('useranalysis') ||$route.path.toLowerCase().includes('usageanalysis')}" class="mb-1 pt-0 pt-1 pb-1" style="max-height:50px" v-bind="attrs" v-on="on">
                                <v-list-item-icon class="mr-2">
                                    <div v-if="$route.path.toLowerCase().includes('useranalysis') || $route.path.toLowerCase().includes('usageanalysis')" class="vlist-border"></div>
                                    <v-img :src="checkLink(item) ? item.active : item.normal" :width="24" :height="24" class="vlist-icon" cover/>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class= "vlist-font ">{{ item.name }}</v-list-item-title>
                                </v-list-item-content>
                                </v-list-item>
                            </template>
                            <v-list class="pa-0" >
                                <v-list-item @click="toUsageAnalysis()">
                                    <v-list-item-title class= "menubarfont ">
                                        {{ $t('GPT_MENU.USAGE_ANALYSIS') }}
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="toUserAnalysis()">
                                     <v-list-item-title class= "menubarfont ">
                                        {{ $t('GPT_MENU.USER_ANALYSIS') }}
                                     </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <!-- 其餘以單個按鈕來使用 -->
                        <v-list-item v-else v-show='isAdmin=="true" || item.isAdmin == false' class="mb-1 pt-0 pt-1 pb-1" style="max-height:50px" :key="`${item.name}-1`"  :to="item.path" >
                            <v-list-item-icon class="mr-2">
                                <div v-if='$route.path.includes(item.path)' class="vlist-border"></div>
                                <v-img :src="checkLink(item) ? item.active : item.normal" :width="24" :height="24" class="vlist-icon" cover/>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="vlist-font">{{ item.name }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                        <v-divider class="ma-0 mx-2 mb-1"></v-divider>
                        <v-list-item class="mb-1 pt-0 pt-1 pb-1" style="max-height:50px" v-for="item in upDayRouterFiltered"   :key="item.id"  @click="toPage(item.name)" >
                            <v-list-item-icon class="mr-2" >
                                <!-- <img v-if='item.name =="UpDay"' style='margin-left: 1.1rem;' height='30' src="../assets/images/UpChat.svg"/>-->
                                <v-img :src="checkLink(item) ? item.active : item.normal" :width="24" :height="24" class="vlist-icon" cover/>
                                <!-- <img v-if='item.id =="portal"' style='margin-left: 0.8rem; margin-right: -0.25rem;' height='38' src="../assets/images/upday_little_icon_100.png"/>-->
                                <!-- <img v-else-if='item.name =="UpChat"' style='margin-left: 1.1rem;' width='30' src="../assets/images/UpChat.svg"/>-->
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="vlist-font ">{{ item.name }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                </v-list-item-group>
                <div>
                </div>
            </v-list>
        </div>

        <!-- 登出功能區 -->
        <div v-if="hideAvatar"></div>
        <div v-else-if="menuMember.userid != ''" >
                <!-- <div class="d-flex justify-left align-left mb-4 ml-4">
                    <div class="logo pointer" @click="toUpDay()"><img src="../assets/images/UPDAY.png" /></div>
                </div> -->
                <div class='d-flex justify-space-between align-center px-4' style='max-width:252.92px'>
                    <v-avatar color="aliceBlue" style="height: 36px;min-width: 36px;width: 36px;">
                        <span v-if="menuMember.pic === ''">{{ menuMember.nickname }}</span>
                        <img v-else :src="member.pic" :alt="menuMember.name" />
                    </v-avatar>
                    <div class="pl-1 pt-4 user_icon  mr-3" >
                        <span class='name ellipsis'>
                            {{menuMember.name}}
                        </span>
                        <p class='small_word ellipsis'>
                            {{menuMember.email}}
                        </p>
                    </div>
                    <div style="margin-left: -14px;">
                        <v-menu top offset-y nudge-top="4" max-width="180">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-hide-element='false' icon v-bind="attrs" v-on="on">
                                    <v-img max-height="24" max-width="24" src="@/assets/images/gear.svg"></v-img>
                                </v-btn>
                            </template>
                            <v-list class="pa-0">
                                <v-list-item v-if="isAdmin=='true'" @click="toLoginPageSetting()">
                                    <v-list-item-title class="menubarfont">{{ $t('LOGIN_PAGE_SETTING.TITLE') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="toUserSetting()">
                                    <v-list-item-title class="menubarfont">{{ $t('SETTING.PERSONALSETTING') }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
            </div>
        </div>        
        <v-dialog v-model='messageDialog' width='360' content-class='statusDialog' v-if='messageDialog'>
            <message-dialog @emitMessageDialog='onEmitMessageDialog' :message='message' :errorMessage='errorMessage'></message-dialog >
        </v-dialog>
        <v-dialog v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)'>
            <error-dialog @emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage'></error-dialog>
        </v-dialog>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import PersonalSettingService from "@/services/PersonalSettingService";
    import PreferenceService from "@/services/PreferenceService";
    import passData from "@/services/passData.js";
    import i18n from '/common/plugins/vue-i18n.js';
    import messageDialog from '@/components/Dialog/messageDialog';
    import errorDialog from "@/components/Dialog/errorDialog";
    import {color} from "quill/ui/icons";

    export default {
        name: 'MenuBar',
        props: {
            member: { 
                type: Object 
            }
        },
        components: {
            messageDialog,
            errorDialog,
        },
        data() {
            return {
                upMenuRouters: [
                    // {
                    // 	   path: '/',
                    // 	   name: 'Home',
                    // 	   normal: 'icon-home-border',
                    // 	   active: 'icon-home'
                    // },
                    // {
                    //     path: '/upgpt/Dashboard',
                    //     name: i18n.t('GPT_MENU.DASHBOARD'),
                    //     normal: 'icon-dashboard-border',
                    //     active: 'icon-dashboard',
                    // },
                    {
                        path: '/upgpt/Knowledges',
                        name: i18n.t('GPT_MENU.KNOWLEDGE'),
                        normal: require('../assets/images/knowledge.svg'),
                        active: require('../assets/images/knowledge-B.svg'),
                        isAdmin: false,
                    },
                    {
                        path: '/upgpt/Chatbot',
                        name: i18n.t('GPT_MENU.CHATBOTS'),
                        normal: require('../assets/images/ai_bot.png'),
                        active: require('../assets/images/ai_bot-B.png'),
                        isAdmin: false,
                    },
                    {
                        path: '/upgpt/Agents',
                        name: i18n.t('AGENT.TITLE'),
                        normal: require('../assets/images/AIAgent.svg'),
                        active: require('../assets/images/AIAgent-B.svg'),
                        isAdmin: true,
                    },
                    {
                        path: '/upgpt/ChatHistory',
                        name: i18n.t('GPT_MENU.CHAT_HISTORY'),
                        normal: require('../assets/images/Chat_record.svg'),
                        active: require('../assets/images/Chat_record-B.svg'),
                        isAdmin: true,
                    },
                    {
                        // path: '/upgpt/UserManagement',
                        name: i18n.t('GPT_MENU.USER_MANAGEMENT'),
                        normal: require('../assets/images/User_management.svg'),
                        active: require('../assets/images/User_management-B.svg'),
                        isAdmin: true,
                    },
                    {
                        // path: '/upgpt/UsageAnalysis',
                        name: i18n.t('GPT_MENU.DATA_CENTER'),
                        normal: require('../assets/images/Data_center.svg'),
                        active: require('../assets/images/Data_center-B.svg'),
                        isAdmin: true,
                    },
                    {
                        path: '/upgpt/Uploadrecord/',
                        name: i18n.t('GPT_MENU.UPLOADSTATUS'),
                        normal: require('../assets/images/Upload_record.svg'),
                        active: require('../assets/images/Upload_record-B.svg'),
                        isAdmin: true,
                    },
                    {
                        path: '/upgpt/MeetingRecap/',
                        name: i18n.t('GPT_MENU.MEETINGRECAP'),
                        normal: require('../assets/images/Meeting_record.svg'),
                        active: require('../assets/images/Meeting_record-B.svg'),
                        isAdmin: false,
                    },
                    {
                        path: '/upgpt/AINotebook/',
                        name: i18n.t('GPT_MENU.AINOTEBOOK'),
                        normal: require('../assets/images/AI_note.svg'),
                        active: require('../assets/images/AI_note-B.svg'),
                        isAdmin: true,
                    },
                    // {
                    //     path: '/upgpt/UserSetting/',
                    //     name: i18n.t('SETTING.PERSONALSETTING'),
                    //     normal: require('../assets/images/Setting.svg'),
                    //     active: require('../assets/images/Setting-B.svg'),
                    //     isAdmin: false,
                    // }
                ],
                updayRouter:
                [
                    // {
                    //     path: '/',
                    //     name: "UpDay",
                    //     normal: 'icon-setting-w',
                    //     active: 'icon-setting-b',
                    // },
                    {
                        id:'portal',
                        path: '/UpGPT_Portal/',
                        name: i18n.t('GPT_MENU.PORTAL'),
                        normal: require('../assets/images/UpGPT.svg'),
                        active: require('../assets/images/UpGPT-B.svg'),
                    },
                    {
                        id: 'upchat',
                        name: 'UpChat',
                        normal: require('../assets/images/UpChat.svg'),
                        active: require('../assets/images/UpChat-B.svg'),
                    },

                ],
                downMenuRouter:
                {
                    path: '/Setting',
                    name: i18n.t('SETTING.TITLE'),
                    normal: 'icon-setting-w',
                    active: 'icon-setting-b',
                },
                offset: true,
                isMobile: false,
                isToggle: false,	
                newPic: null,
                userPic: false,
                newName: null,
                newAgentData: null,
                menuMember:{userid:''},
                memberData: null,
                statusColor: 'grey',
                messageDialog: false,
                errorDialog: false,
                message: '',
                errorMessage: "",
                upchat: this.$route.meta.upchat,
                hideAvatar: false,
                isUpchatUser: window.localStorage.getItem('isUpchatUser'),
                isAdmin: window.localStorage.getItem('is_staff'),
                showUpchatDashboard: false,
                hasUpchatLogin: false,
                screen_ratio_class_CIC:"",
                screen_ratio_class:"",
                user:JSON.parse(window.localStorage.getItem('user')),
                show_upmeet_notebook: false,
                logoUrl: require('../assets/images/UPGPT.png'),
                logoHover: false
            };
        },
      computed: {
        color() {
          return color
        },
        upDayRouterFiltered() {
          const filtered = this.updayRouter.filter(item => {
            if (item.id == "portal" && this.menuMember.is_portal_user) {
              return true;
            }
            if (item.id == "upchat" && (this.menuMember.is_service_agent || this.isAdmin)) {
              return true;
            }
            return false;
          });
          return filtered;
        },
        upMenuRouterFiltered() {
          return this.upMenuRouters.filter(item => {
            if (
              item.path === '/upgpt/MeetingRecap/' ||
              item.path === '/upgpt/AINotebook/'
            ) {
              return this.show_upmeet_notebook;
            }
            return true;
          });
        }
      },
        watch: {
            "member":async function () {
                if(this.member.userid != '')
                {
                    this.menuMember = this.member;
                    await this.getUserPhoto();
                }
            },
            "newPic": function () {
                this.menuMember.pic = this.newPic
            },
            "newName": function () {
                this.menuMember.name = this.newName.last_name+' '+this.newName.first_name;				
            },
            "newAgentData": function () {
                this.menuMember.is_service_agent = this.newAgentData.is_service_agent;
                this.menuMember.is_portal_user = this.newAgentData.is_portal_user;
                this.menuMember.status = this.newAgentData.status;
            }
        },
        created() {
            if (window.localStorage.getItem('upchat_login') != null){
                this.hasUpchatLogin = window.localStorage.getItem('upchat_login') === 'true' ? true : false;
            }
            this.menuMember = this.member;
            this.menuMember.email = this.user.email;
            let access_token = window.localStorage.getItem('access_token');
            if(access_token != null){
                this.getUserDetail();
            }
            window.addEventListener("message",(msg)=>{this.hide(msg.data)}, false);
            window.addEventListener('resize', () => {this.return_screen_class()})
            this.return_screen_class();
            this.get_upgpt_setting();
            this.getUpGPTMenuLogo();
        },
        mounted() {
            
            passData.$on("menuBarPic", (e) => {
                this.newPic = e
            })
            passData.$on("menuBarName", (e) => {
                this.newName = e
            })
            passData.$on("menuBarAgentData", (e) => {
                this.newAgentData = e;
            })
            passData.$on("status", () => {
                if(this.menuMember.is_service_agent){
                    this.changeStatus('ONLINE');
                }
            })
        },
        methods: {
            async get_upgpt_setting(){
                let setting = await this.upgpt_image_func_setting();
                this.show_upmeet_notebook = setting['show_upmeet_notebook'];
            },
            return_screen_class(){
                let ratio = window.innerWidth/window.outerWidth;
                if(ratio <= 0.8){
                    this.screen_ratio_class_CIC = "bg-CIC mb-2 v-list-item-small";
                    this.screen_ratio_class = "mb-2 v-list-item-small" ;
                }else{
                    this.screen_ratio_class_CIC = "bg-CIC mb-2";
                    this.screen_ratio_class = "mb-2" ;
                }
            },
            remove_upchat_icon(){
                this.upMenuRouters = this.upMenuRouters.filter(el =>el.name != "UpChat" && el.name != i18n.t('UPCHAT.CIC'));
            },
            hide(msg){
                if(msg == 'hide Avatar'){
                    this.hideAvatar = true;
                }
            },
            // async beforeUnloadHandler(e, newStatus){
            //     // 
            //     await this.changeUserStatus(newStatus);
            //     // call API to update
            //     navigator.sendBeacon(`http://127.0.0.1:8000//tenant/demo_2/api/personalsetting/${this.memberData[0].id}/status/`, this.memberData[0])
            //     // await PersonalSettingService.updateStatus(this.memberData[0].id, this.memberData[0]);
            // },
            // async changeUserStatus(newStatus){
            //     // set memberData data to new status
            //     this.memberData[0].usersetting.status = newStatus;

            //     // set menuMember data to new status
            //     this.menuMember.status = newStatus;
                
            //     // set local storage data to new status
            //     let userJson = window.localStorage.getItem('user');
            //     let user = JSON.parse(userJson);
            //     user.status = newStatus;
            //     window.localStorage.setItem('user', JSON.stringify(user));
            // },
            async getUserDetail(){
                await PersonalSettingService.getCurrentUserDetail()
                .then(response => {
                    this.memberData = response.data;
                })
            },
            setLang(){
                let lang = window.localStorage.getItem('language');
                if(lang != 'zh_TW')
                {
                    window.location.reload();
                }
            },
            getUserPhoto(){
                if(this.userPic === false){
                    PersonalSettingService.getCurrentUserDetail()
                    .then(response => 
                    {
                        if(response.data[0].usersetting.photo != null)
                        {
                            this.menuMember.pic = response.data[0].usersetting.photo						
                            const USER = 'user';
                            let userJson = window.localStorage.getItem(USER);
                            let user = JSON.parse(userJson);
                            user.pic = response.data[0].usersetting.photo;
                            window.localStorage.setItem(USER, JSON.stringify(user));	
                            this.userPic = true
                        }
                        else{
                            this.menuMember.pic = '';
                        }
                        this.setLang()
                    })
                }
            },
            checkLink: function (item) {
                const windowsHref = this.$route.path;
                if(item.name == i18n.t('Bulk_Message.TITLE')){
                    if (windowsHref == '/Segments' || windowsHref == '/Campaigns'){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
                else if (item.name == i18n.t('GENERAL.DASHBOARD')) {
                    if (windowsHref == '/DealDashboard' || windowsHref == '/CaseDashboard'){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
                else if (item.name == i18n.t('GPT_MENU.KNOWLEDGE')) {
                    if (windowsHref == '/upgpt/Knowledges'){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
                else if (item.name == i18n.t('GPT_MENU.USER_MANAGEMENT')) {
                    if (windowsHref == '/upgpt/UserManagement' || windowsHref == '/upgpt/GroupManagement'){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
                else if (item.name == i18n.t('GPT_MENU.DATA_CENTER')) {
                    if (windowsHref == '/upgpt/UserAnalysis' || windowsHref == '/upgpt/UsageAnalysis'){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
                else{
                    if (windowsHref.includes(item.path))
                        return true;
                    else
                        return false;
                }
            },
            addDivider(item){
                if(item.name == i18n.t('Bulk_Message.TITLE')){
                    return true;
                }
                else if (item.name == i18n.t('COMPANY.TITLE')) {
                    return true;
                }
                else if (item.name == i18n.t('GENERAL.ACTIVITY')) {
                    return true;
                }
                else{
                    return false;
                }
            },
            toSegments(){
                if(this.$route.path !== '/Segments') this.$router.push('/Segments');
            },
            toCampaigns(){
                if(this.$route.path !== '/Campaigns') this.$router.push('/Campaigns');
            },
            toDealDashboard(){
                if(this.$route.path !== '/DealDashboard') this.$router.push('/DealDashboard');
            },
            toCaseDashboard(){
                if(this.$route.path !== '/CaseDashboard') this.$router.push('/CaseDashboard');
            },
            toUpChatDashboard(){
                let userJson = JSON.parse(window.localStorage.getItem('user'));
                if (userJson.upchat_dashboard != '') {
                    // if not login, put sso link to iframe src first
                    if (userJson.upchat_sso_link != '') {
                        window.open(userJson.upchat_dashboard, '_blank');
                    }
                }
            },
            toPage(val){
                if(val == "UpDay"){
                    this.toUpDay();
                }
                else if(val == "Portal") {
                  this.toUpGPT_Portal();
                }
                else{
                    this.toUpChatHost();
                }
            },
            async toUpChatHost(){
                let userJson = JSON.parse(window.localStorage.getItem('user'));
                let upchat_login = JSON.parse(window.localStorage.getItem('upchat_login'));
                if (userJson.upchat_host != '') {
                    if (userJson.upchat_sso_link != '') {
                        if(upchat_login){
                           window.open(userJson.upchat_host, '_blank'); 
                        }else{
                            window.open(userJson.upchat_sso_link, '_blank');
                            window.localStorage.setItem('upchat_login', true);
                        }
                    }else{
                        window.open(userJson.upchat_host, '_blank');
                    }
                }else{
                    console.log("upchat_host", userJson.upchat_host)
                    console.log("upchat_sso_link", userJson.upchat_sso_link)
                    await PreferenceService.getUPCHAT().then((response)=>{
                        let host = response.data['host']
                        if (host){
                            window.open(host, '_blank'); 
                        }else{
                            this.showErrorDialog("Wrong UpChat Setting");
                        }
                    })
                }
            },
            toSetting(){
                this.$router.replace('/upgpt/UserSetting/')
            },
            toUpGpt(){
                if(this.$route.path !== '/upgpt/') this.$router.push('/upgpt/');
            },
            toUpDay(){
                if(this.$route.path !== '/') this.$router.push('/');
            },
            toUpGPT_Portal(){
                if(this.$route.path !== '/UpGPT_Portal/') this.$router.push('/UpGPT_Portal/');
            },
            toUserManagement(){
                if(this.$route.path !== '/upgpt/UserManagement') this.$router.push('/upgpt/UserManagement');
            },
            toGroupManagement(){
                if(this.$route.path !== '/upgpt/GroupManagement') this.$router.push('/upgpt/GroupManagement');
            },
            toUsageAnalysis(){
                if(this.$route.path !== '/upgpt/UsageAnalysis') this.$router.push('/upgpt/UsageAnalysis');
            },
            toUserAnalysis(){
                if(this.$route.path !== '/upgpt/UserAnalysis') this.$router.push('/upgpt/UserAnalysis');
            },
            toUserSetting(){
                if(this.$route.path !== '/upgpt/UserSetting') this.$router.push('/upgpt/UserSetting');
            },
            toLoginPageSetting(){
                if(this.$route.path !== '/upgpt/LoginPageSetting') this.$router.push('/upgpt/LoginPageSetting');
            },
            async onlogout() {
                this.messageDialog =  true;
                this.message = i18n.t("GENERAL.LOGOUT_MSG");
                // if(this.menuMember.is_service_agent){
                //     this.memberData[0].usersetting.status = 'OFFLINE';
                //     this.memberData[0].usersetting.default_value = JSON.parse(window.localStorage.getItem('user')).default_value
                //     await PersonalSettingService.updateDetail(this.memberData[0].id, this.memberData[0])
                // }
                // let tenant = window.localStorage.getItem('tenant');

                // await this.logout()
                // .then(() => {
                //     let redirectTo = (tenant != null || tenant != '') ? `/login?tenant=${tenant}` : '/login';
                //     this.menuMember = { userid: ''};
                //     this.userPic = false;
                //     this.$emit('logoutSuccess');
                //     this.$router.push(redirectTo);
                //     this.showUpchatDashboard = false;
                //     this.remove_upchat_icon();
                // })
            },
            // onResize: function () {
            //     if (window.innerWidth < 767) {
            //         this.isMobile = true;
            //     }
            // },
            toggleMenu() {
                if (this.isToggle == false) {
                    this.isToggle = true;
                } else {
                    this.isToggle = false;
                }
            },
            ...mapActions([
                'logout',
            ]),
            async changeStatus(newStatus){
                await this.getUserDetail();
                if(this.memberData != null){
                    this.memberData[0].usersetting.status = newStatus;

                    PersonalSettingService.updateDetail(this.memberData[0].id, this.memberData[0]).then(response => {
                        // set menuMember data to new status
                        this.menuMember.status = response.data.usersetting.status;

                        // set local storage data to new status
                        let userJson = window.localStorage.getItem('user');
                        let user = JSON.parse(userJson);
                        user.status = response.data.usersetting.status;
                        window.localStorage.setItem('user', JSON.stringify(user));
                    }).catch(response => {
                        console.log(response);
                    })
                }
            },
            async onEmitMessageDialog(val){
                this.messageDialog = false;
                if(val){
                    if(this.menuMember.is_service_agent){
                        this.memberData[0].usersetting.status = 'OFFLINE';
                        this.memberData[0].usersetting.default_value = JSON.parse(window.localStorage.getItem('user')).default_value
                        await PersonalSettingService.updateDetail(this.memberData[0].id, this.memberData[0])
                    }
                    let tenant = window.localStorage.getItem('tenant');

                    await this.logout().then(() => {
                        let redirectTo = (tenant != null || tenant != '') ? `/upgpt-login?tenant=${tenant}` : '/upgpt-login';
                        this.menuMember = { userid: ''};
                        this.userPic = false;
                        this.$emit('logoutSuccess');
                        this.$router.push(redirectTo);
                        this.showUpchatDashboard = false;
                        this.remove_upchat_icon();
                    })
                }
            },
            showErrorDialog(message) {
                this.errorDialog = true;
                this.errorMessage = message;
            },
            onEmitErrorDialog() {
                this.errorDialog = false;
            },
            triggerFile(){
                this.$refs.fileInput.click();
            },
            async onLogoChange(e){
                let file = e.target.files[0];
                if(!file) return;
                let acceptTyppes = ['image/jpeg','image/jpg', 'image/png'];
                if(!acceptTyppes.includes(file.type)){
                    this.showErrorDialog(i18n.t('UPGPT.WRONGTYPEINIMAGEFILE'));
                    return;
                }
                if(e.size > 5242880) {
                    this.showErrorDialog(i18n.t('GPT_AIBOTS.IMG_ERROR_2'));
                    return;
                }
                await PersonalSettingService.uploadGPTMenuLogo(file)
                .then((response)=>{
                    this.logoUrl = response.data;
                    this.getUpGPTMenuLogo();
                });
            },
            async getUpGPTMenuLogo(){
                await PreferenceService.getUPGPTMenuLogo().then((response)=>{
                    this.logoUrl = response.data == "" ? require('../assets/images/UPGPT.png') : response.data;
                })
            },
            mouseenter(){
                this.logoHover = true;
            },
            mouseleave(){
                this.logoHover = false;
            },
        }
    }
</script>
<style scoped>
  .v-list-item-group .v-list-item--active {
    color: #18bedf ;
    background-color: #18bedf10;
  }
  .menubarfont {
      font-weight: 500 !important;
      font-size: 14px !important;
      line-height: 150% !important;
      letter-spacing: 0.5px !important;
      color: #444444 !important;
  }
</style>